export default [
    {
        path: '/database-query/list',
        name: 'database_query_list',
        component: () => import('@src/database-query/database-query-list.vue'),
        meta: {
            title: 'Datenbankabfragen',
            role: 'ROLE_SHOW_DATABASE_QUERY',
        },
    },
    {
        path: '/database-query/create',
        name: 'database_query_create',
        component: () => import('@src/database-query/database-query-create.vue'),
        meta: {
            title: 'Datenbankabfrage anlegen',
            role: 'ROLE_EDIT_DATABASE_QUERY',
        },
    },
    {
        path: '/database-query/edit/:id',
        name: 'database_query_edit',
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/database-query/database-query-edit.vue'),
        meta: {
            title: 'Datenbankabfrage bearbeiten',
            role: 'ROLE_EDIT_DATABASE_QUERY',
        },
    },
    {
        path: '/database-query/result/:id',
        name: 'database_query_result',
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/database-query/database-query-result.vue'),
        meta: {
            title: 'Datenbankabfrage abrufen',
            role: 'ROLE_SHOW_DATABASE_QUERY',
        },
    },
];
